import { combineReducers } from "@reduxjs/toolkit";
import myProfile from "../organisms/MyProfile/ducks/reducers";
import company from "../organisms/Company/ducks/reducers";
import team from "../organisms/Team/ducks/reducers";
import users from "../organisms/Users/ducks/reducers";
import crewYard from "../organisms/CompanySettings/CrewYards/ducks/reducers";
import inventory from "../organisms/Inventory/ducks/reducers";
import tags from "../organisms/CompanySettings/TagsCategories/ducks/reducers";
import takeOff from "../organisms/CompanySettings/TakeoffMeasurements/ducks/reducers";
import unit from "../organisms/CompanySettings/MeasurementsUnits/ducks/reducers";
import services from "../organisms/CompanySettings/Services/ducks/reducers";
import clients from "../organisms/Clients/ducks/reducers";
import crewsSubs from "../organisms/CrewsSubs/ducks/reducers";
import laborRates from "../organisms/CompanySettings/LabourHourlyRates/ducks/reducers";
import properties from "../organisms/Properties/ducks/reducers";
import potentialDeal from "../organisms/PotentialDeals/ducks/reducers";
import schedule from "../organisms/Scheduling/ducks/reducers";

const rootReducer = combineReducers({
  myProfile,
  company,
  team,
  users,
  crewYard,
  inventory,
  tags,
  takeOff,
  unit,
  services,
  clients,
  crewsSubs,
  laborRates,
  properties,
  potentialDeal,
  schedule,
});

export default rootReducer;
